import React from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import { useLocation } from "react-router-dom";

import { useAppSelector } from "@/redux/store";
import { getSEOStructuredProduct } from "@/util/seo";
import { selectProductDetails } from "../selectors";
import { useCurrency } from "@/hooks";

const PDPHelmet = () => {
  const meta = useAppSelector(state => state.seo.meta);
  const productDetails = useSelector(selectProductDetails);
  const currencyCode = useCurrency();
  const location = useLocation();

  if (!meta.isIndexable) return null;

  const seoStructuredProductData = getSEOStructuredProduct(
    productDetails,
    location,
    currencyCode
  );

  return <Helmet script={[helmetJsonLdProp(seoStructuredProductData)]} />;
};

export default PDPHelmet;
